import { useEffect, useState } from 'react'

export interface Me {
  authenticated: boolean
  sub: string | null
  email: string | null
  name: string | null
}

const ANON: Me = { authenticated: false, sub: null, email: null, name: null }

/** Who is signed in (gateway identity, verified server-side via /api/me). */
export function useMe(): Me | null {
  const [me, setMe] = useState<Me | null>(null)
  useEffect(() => {
    fetch('/api/me')
      .then((r) => r.json())
      .then((m: Me) => setMe(m))
      .catch(() => setMe(ANON))
  }, [])
  return me
}
